import { Component, Optional } from '@angular/core';
import { ParentItemProviderService } from '@app/shared';
import { OpenArhivWindowActionUtil } from '@app/shared/util/open-arhiv-window-util';
import {
  ActionWindowParams,
  EMPTY_ACTION_RESULT,
  Item,
  ItemActionResult,
  ItemUtil,
  ListView,
  ListViewProviderDirective,
  NotificationService,
  NtapGlobalConstants,
  Util,
  ViewState,
  ViewWindow,
  WindowRegistry
} from '@ntap/core';
import { ViewResult } from '@ntap/core/lib/view/view-result';
import { PrimeNGButtonNewItemViewActionComponent } from '@ntap/primeng';
import { filter, map, mergeMap, Observable, first, tap, of } from 'rxjs';

@Component({
  selector: 'app-new-child-entity-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html',
  styleUrls: ['./new-child-entity-action.component.scss']
})
export class NewChildEntityActionComponent extends PrimeNGButtonNewItemViewActionComponent {
  constructor(
    protected override notificationService: NotificationService,
    protected override windowRegistry: WindowRegistry,
    @Optional() protected override window: ViewWindow,
    protected listViewProvider: ListViewProviderDirective<ListView>,
    @Optional()
    protected parentItemViewProviderService: ParentItemProviderService
  ) {
    super(notificationService, windowRegistry, window, listViewProvider);
  }

  protected override doExecuteWithItem(
    item: Item
  ): Observable<ItemActionResult> {
    const parentItem$: Observable<any> =
      this.parentItemViewProviderService?.parentItem$ ??
      of((item as any)[NtapGlobalConstants.ATTR_$parent]);
    const keyItem = ItemUtil.extractItemKey(item);
    return parentItem$.pipe(
      first(),
      mergeMap((parentItem: any) => {
        const parentItemMainType =
          parentItem[NtapGlobalConstants.ATTR_$itemType] ||
          parentItem[NtapGlobalConstants.ATTR_$mainType];

        const parentItemIdAttrName = Util.getFullAttrName(
          parentItemMainType,
          NtapGlobalConstants.ATTR_id
        );

        const parentItemId = parentItem[parentItemIdAttrName];

        const parentItemProps =
          (parentItemId && {
            $parentId: parentItemId,
            $parentType: parentItemMainType,
            $itemType: parentItemMainType
          }) ||
          {};

        const viewState = Object.assign({}, keyItem, parentItemProps);

        return this.doOpenWindow(viewState).pipe(
          filter((viewResult) => this.acceptResult(viewResult)),
          tap(() => this.log('result ACCEPTED')),
          map(
            (viewResult) =>
              new ItemActionResult(EMPTY_ACTION_RESULT, viewResult.viewData[0])
          )
        );
      })
    );
  }

  private doOpenWindow(viewState: ViewState): Observable<ViewResult> {
    return OpenArhivWindowActionUtil.open(
      this.getActionWindowParams(),
      viewState
    );
  }

  protected override getActionWindowParams(): ActionWindowParams {
    this.doSetDefaultActionViewName();
    const actionWindowParams = OpenArhivWindowActionUtil.createParams(
      this.action,
      this.windowRegistry,
      this.getWindowTarget()
    );

    return actionWindowParams;
  }

  private doSetDefaultActionViewName() {
    if (!this.action.$openViewName) {
      this.action.$openViewName = '$defaultItemView';
    }
  }
}
